import './App.css';
import ProfileCard from './components/ProfileCard';
import React, { useEffect, useState } from 'react';

function App() {
	const [userData, setUserData] = useState({});
	const [triggerFetch, setTriggerFetch] = useState(false);

	const fetchUserData = async () => {
		const response = await fetch('https://randomuser.me/api/');
		const data = await response.json();
		setUserData(setFields(data.results[0]));
	};

	const setFields = (userData) => {
		const fName = userData.name.first;
		const lName = userData.name.last;
		const fullName = fName + ' ' + lName;
		return {
			image: userData.picture.large,
			name: fullName,
			email: userData.email,
			dob: userData.dob.date,
			location: userData.location.street.name,
			phone: userData.phone,
			password: userData.login.password,
		};
	};

	useEffect(() => {
		fetchUserData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [triggerFetch]);

	//this triggers fetch
	const handleRandomUserClick = () => {
		setTriggerFetch(!triggerFetch);
	};

	return (
		<main>
			<div className='grey-bg'></div>

			<ProfileCard
				userData={userData}
				handleRandomUserClick={handleRandomUserClick}
			/>
		</main>
	);
}

export default App;
